export default "__VITE_ASSET__3383aa25__"